// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// ***************************************************************** SettingPacks *******************************************************************
const INDEX_ASSIGNMENT_USER_SETTING_PACKS_SUCCESS = 'INDEX_ASSIGNMENT_USER_SETTING_PACKS_SUCCESS';
const INDEX_ASSIGNMENT_POSITION_SETTING_PACKS_SUCCESS = 'INDEX_ASSIGNMENT_POSITION_SETTING_PACKS_SUCCESS';
const STORE_ASSIGNMENT_SETTING_PACK_SUCCESS = 'STORE_ASSIGNMENT_SETTING_PACK_SUCCESS';

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ***************************************************************** SettingPacks *******************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexUserSuccess(payload) {
  return {
    type: INDEX_ASSIGNMENT_USER_SETTING_PACKS_SUCCESS,
    payload: payload,
  };
}
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexPositionSuccess(payload) {
  return {
    type: INDEX_ASSIGNMENT_POSITION_SETTING_PACKS_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeSuccess(payload) {
  return {
    type: STORE_ASSIGNMENT_SETTING_PACK_SUCCESS,
    payload: payload.data,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// ***************************************************************** Settings *******************************************************************
/**
 *
 * @param {String} [component]
 * @param {Number} [id]
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function index(component = 'user', id, params = {}, callback = () => {
}) {
  return (dispatch, gs, api) => {
    let routes = `positions/${id}/setting-packs`;
    if (component === 'user') {
      routes = `users/${id}/setting-packs`;
    }
    api.get(routes , {params})
      .then((r) => {
        if (component === 'user') {
          dispatch(_indexUserSuccess(r));
        } else {
          dispatch(_indexPositionSuccess(r));
        }
        callback(false, r);
      })
      .catch((e) => {
        callback(e);
      });
  };
}

/**
 *
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function store(data, callback = () => {
}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(app.translate('routes.home.attendance.setting.Adding New Setting'));

    api.post('/setting-packs/assign', {data})
      .then((r) => {
        dispatch(_storeSuccess(r));
        loader.hide(() => app.message(app.translate('routes.home.attendance.setting.New Setting Added Successfully')));
        callback(r);
      })
      .catch((e) => {
        loader.hide(() => app.error(
          e, 'routes.home.attendance.setting', 'خطا در ارسال اطلاعات',
          app.translate('routes.home.attendance.setting.Adding New Setting Failed'),
        ));
      });
  };
}

/**
 *
 * @return {Function}
 */
export function emptySettingPacks() {
  return _indexUserSuccess({data: {settingPacks: []}, meta: {}});
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(state = {
  settingPacks: [],
}, action) {
  let settingPacks;

  switch (action.type) {
    case INDEX_ASSIGNMENT_USER_SETTING_PACKS_SUCCESS:
      return Object.assign({}, state, {
        settingPacks: action.payload.data && action.payload.data.user ? action.payload.data.user.settingPacks: [],
      });
    case INDEX_ASSIGNMENT_POSITION_SETTING_PACKS_SUCCESS:
      return Object.assign({}, state, {
        settingPacks: action.payload.data? action.payload.data : [],
      });
    case STORE_ASSIGNMENT_SETTING_PACK_SUCCESS:
      settingPacks = app._.clone(state.settingPacks);
      settingPacks.push(action.payload);
      return Object.assign({}, state, {
        settingPacks,
      });
    default:
      return state;
  }
}
